export const environment = {
  production: false,
  apiUrl: 'https://2b49a7m3k1.execute-api.us-west-2.amazonaws.com/dev',
  whatsappNumber: '573000000000',
  whatsappMessage: 'Hola Crescio Engine, quiero información sobre un proyecto de software.',
};
